import { Component } from '@angular/core';
import { LanguageService } from './core/services/languages-service/languajes.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'degesco-frontoffice';
  recorded:boolean=false;
  constructor(private translate: TranslateService) {
    translate.setDefaultLang('es');
    translate.use('es');
  }

  onRecorded(value: boolean) {
    //console.log(value ? "Grabado" : "No grabado");
    this.recorded = value;
  }
}
